import { createHttpInstance } from "../http/httpFactory";

const userHttp = createHttpInstance({
  baseURL: process.env.REACT_APP_BASE_URL, // || "https://api.cashquin.com",
  withCredentials: true,
  name: "user",
  // timeout: 20000,
  defaultHeaders: {
    "Content-Type": "application/json",
  },
});

export default userHttp;
